import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';

import Header from 'components/admin/Header';
import Sniplet from 'components/Sniplet';
import SuggestResult from 'components/Suggest/Result';
import { fetchUserInfo } from 'actions/user';

if (process.env.NODE_ENV !== 'test') {
  require('styles/application.scss');
  require('./App.scss');
}

class AdminApp extends Component {
  static displayName = 'AdminApp';

  constructor(props) {
    super(props);

    props
      .fetchUserInfo()
      .catch(e => console.error('Error fetching user info', e));
  }

  getParams = () => {
    const pl = /\+/g; // Regex for replacing addition symbol with a space
    const search = /([^&=]+)=?([^&]*)/g;
    const decode = s => decodeURIComponent(s.replace(pl, ' '));
    const query = this.props.location.search.substring(1);

    let match;
    let urlParams = {};
    while ((match = search.exec(query))) {
      urlParams[decode(match[1])] = decode(match[2]);
    }

    return urlParams;
  };

  render() {
    const { user, location, component: Page, ...props } = this.props;
    const isFetching = user.get('isFetching');
    const type = user.get('type');
    const loggedIn = type === 'admin' || type === 'support_takeover';

    if (isFetching) return null;
    if (!loggedIn) {
      return <Redirect to="/admin/login" />;
    }

    /** Pass URL params as object for backwards compat */
    const params = this.getParams();
    const match = props.computedMatch || props.match;

    return (
      <div className="AdminApp application">
        <Header />
        <Sniplet name="Driftsmelding" />

        <div className="container">
          <Page
            {...props}
            params={{ ...match.params, ...params }}
            match={match}
            location={{ ...location, query: params }}
          />
        </div>
        <SuggestResult />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  return {
    user,
  };
}

export default compose(
  withRouter,
  connect(mapStateToProps, { fetchUserInfo }),
)(AdminApp);
